import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Row } from 'reactstrap';
import DragDropComponente from '@componentes/dragdrog/dragdrop.componente';
import ItemKanbam from './Item';
import CancelamentoComponent from '@componentes/cancelamento/cancelamento.component';
import ModalDetalhes from '../modais/Detalhes';
import {
  arquivamentoTipoEmum,
  retornaTipo,
  retornaIcone,
  retornaIconeDestino,
  requisicaoMaterialTipoEntregaOptions
} from '../../../arquivamento.utils';
import ArquivamentoApi from '../../../arquivamento.api';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import IntlMessage from '../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function Kamban ({ lista }, props) {
  const intl = useIntl()
  const dispatch = useDispatch();
  
  const [listaKanbam, setListaKanbam] = useState([]);
  const [listaItens, setListaItens] = useState([]);
  const [showModalRemover, setShowModalRemover] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState({});
  const [justificativaCancelamento, setJustificativaCancelamento] = useState(
    ''
  );
  
  useEffect(() => {
    const listaFormatada = lista.map(i => ({
      ...i,
      numero: `${retornaTipo(i.tipo, intl)} ${i.numero}`,
      iconeDestino: retornaIconeDestino(i.nrDestinoEntrega),
      tipoNome: retornaTipo(i.tipo,intl),
      destinoEntrega: requisicaoMaterialTipoEntregaOptions.find(
        x => x.value === i.nrDestinoEntrega
      ).label
    }));
    setListaItens(listaFormatada);
  }, [lista]);

  useEffect(() => {
    
    let pendentes = listaItens
      .filter(el => el.status === quadroKanbanEnum.AM_SOLICITADOS.status)
      .map(el =>
        criarItemKanbam(
          el,
          retornaIcone(el.tipo),
          quadroKanbanEnum.AM_SOLICITADOS.status
        )
      );

    let arquivados = listaItens
      .filter(el => el.status === quadroKanbanEnum.AM_ARQUIVADOS.status)
      .map(el =>
        criarItemKanbam(
          el,
          retornaIcone(el.tipo),
          quadroKanbanEnum.AM_ARQUIVADOS.status
        )
      );

    setListaKanbam(getKanbam(pendentes, arquivados));
  }, [listaItens]);

  function criarItemKanbam (item, icone, etapa) {
    let id = `item_${item.idRequisicao}_${etapa}`;
    return {
      id: id,
      data: item,
      isDragDisabled: false,
      content: (
        <ItemKanbam
          item={item}
          icone={icone}
          id={id}
          apagar={apagar}
          detalhes={detalhes}          
        />
      )
    };
  }

  function getKanbam (pendentes, arquivados) {
    return [
      {
        pendentes: pendentes,
        title: { text: `${intl.formatMessage({id:"general.materialArchiving.requested"}) }`, color: colorsSystem.DG2 },
        count: pendentes.length
      },

      {
        arquivados: arquivados,
        title: { text: `${intl.formatMessage({id:"general.materialArchiving.completed"}) }`, color: colorsSystem.DG5 },
        count: arquivados.length
      }
    ];
  }

  function onDragEndOverride (result) {
    const { source, destination } = result;

    var origem = {
      pendentes: quadroKanbanEnum.AM_SOLICITADOS.status,
      arquivados: quadroKanbanEnum.AM_ARQUIVADOS.status
    };

    var itemCard =
      listaKanbam[origem[source.droppableId]][source.droppableId][source.index];

    if (
      destination &&
      destination.droppableId === quadroKanbanEnum.AM_ARQUIVADOS.id
    ) {
      salvar({ ...itemCard.data, status: quadroKanbanEnum.AM_ARQUIVADOS.status });
    } else {
      salvar({ ...itemCard.data, status: quadroKanbanEnum.AM_SOLICITADOS.status });
    }
  }

  function move (itemMovido) {
    const lista = listaItens.map(item => {
      return item.idRequisicao === itemMovido.idRequisicao
        ? { ...itemMovido }
        : { ...item };
    });
    setListaItens(lista);
  }

  function salvar (item) {
    dispatch(commonActions.showFadeCarregando(true));

    ArquivamentoApi.updateRequisicao(item).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));

      if (resp) {
        move(item);
        const message =
          item.tipo === arquivamentoTipoEmum.BLOCO
            ? <IntlMessage id="general.materialArchiving.blockMoved" />
            : <IntlMessage id="general.materialArchiving.movedBlade" />;
        dispatch(
          commonActions.showAlerta('sucesso', `${message} com sucesso`, 3000)
        );
      } else {
        const message =
          item.tipo === arquivamentoTipoEmum.BLOCO ? <IntlMessage id="general.materialArchiving.theBlock" /> : <IntlMessage id="general.materialArchiving.theBlade" />;
        dispatch(
          commonActions.showAlerta(
            'erro',
            `${<IntlMessage id="general.materialArchiving.anErrorOccurred" />} ${message}`,
            3000
          )
        );
      }
    });
  }

  function detalhes (item) {
    setItemSelecionado(item);
    setShowModalDetalhes(!showModalDetalhes);
  }

  function apagar (item) {
    setItemSelecionado(item);
    setShowModalRemover(true);
  }

  function removerItem () {
    dispatch(commonActions.showFadeCarregando(true));
    ArquivamentoApi.deleteRequisicao(
      itemSelecionado.idRequisicao,
      justificativaCancelamento
    ).then(resp => {
      const lista = listaItens.filter(
        item => item.idRequisicao !== itemSelecionado.idRequisicao
      );
      setListaItens(lista);
      setJustificativaCancelamento('');
      setShowModalRemover(false);
      dispatch(commonActions.showFadeCarregando(false));
      dispatch(
        commonActions.showAlerta(
          'sucesso',
          <IntlMessage id="general.materialArchiving.requestCancellationCompleted" />,
          3000,
          '450px'
        )
      );
    });
  }

  return (
    <Row>
      <CancelamentoComponent
        intl={intl}
        isOpen={showModalRemover}
        toggle={() => {
          setJustificativaCancelamento('');
          setShowModalRemover(!showModalRemover);
        }}
        setJustificativa={setJustificativaCancelamento}
        justificativaCancelar={justificativaCancelamento}
        cancelarEtapa={removerItem}
        title={`${intl.formatMessage({id: 'general.materialArchiving.materialRequisitionCancellation'})}`}
        confirmTextLabel={'Confirmar'}
      />
      <ModalDetalhes
        onModal={() => setShowModalDetalhes(!showModalDetalhes)}
        itemSelecionado={itemSelecionado}
        showModalDetalhes={showModalDetalhes}
      />
      <DragDropComponente
        {...props}
        list={listaKanbam}
        onDragEndOverride={onDragEndOverride}
      />
    </Row>
  );
}

export default Kamban;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/Kamban/index.js